import * as React from "react";
import CheckCircle from "../../../icons/CheckCircle";
import Circle from "../../../icons/CircleEmpty";
import AlertCircle from "../../../icons/AlertCircle";
import CloseCircle from "../../../icons/CloseCircle";
import StyledIconWrapper from "../primitives/StyledIconWrapper";
const getTypeIcon = ({
  type,
  active
}) => {
  if (type === "success" && active) return /*#__PURE__*/React.createElement("svg", {
    height: "16",
    width: "16",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "green",
    strokeWidth: "1px",
    cx: "8",
    cy: "8",
    r: "6"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "green",
    stroke: "none",
    cx: "8",
    cy: "8",
    r: "3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.1"
  })));
  if (type === "success") return /*#__PURE__*/React.createElement(CheckCircle, {
    color: "success",
    size: "small"
  });
  if (type === "warning") return /*#__PURE__*/React.createElement(AlertCircle, {
    color: "warning",
    size: "small"
  });
  if (type === "critical") return /*#__PURE__*/React.createElement(CloseCircle, {
    color: "critical",
    size: "small"
  });
  return /*#__PURE__*/React.createElement(Circle, {
    color: "tertiary",
    size: "small"
  });
};
const TypeIcon = ({
  type,
  active,
  mobile
}) => {
  return /*#__PURE__*/React.createElement(StyledIconWrapper, {
    mobile: mobile,
    status: type,
    active: active
  }, getTypeIcon({
    type,
    active
  }));
};
export default TypeIcon;